//
import SlSaleTicketModel from '@/models/Sale/SlSaleTicket'

//
export default class SlSaleTicketService {

  /**
   * 
   */
  static getByNumber(number) {
    return this
      .model()
      .from()
      .many('number/' + number)
      .include(
        'sl_detail_sale_tickets.wh_product', 
        'first_pos_sale',
        )
      .get()
  }

  /**
   *  Returns the model
   */
  static model() {
    return SlSaleTicketModel
  }
}